var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.4987C9.11578 2.4987 8.26794 2.84989 7.64281 3.47501C7.01769 4.10013 6.6665 4.94798 6.6665 5.83203V8.33203H13.3332V5.83203C13.3332 4.94798 12.982 4.10013 12.3569 3.47501C11.7317 2.84989 10.8839 2.4987 9.99984 2.4987ZM14.9998 8.33203V5.83203C14.9998 4.50595 14.4731 3.23418 13.5354 2.2965C12.5977 1.35882 11.3259 0.832031 9.99984 0.832031C8.67376 0.832031 7.40199 1.35882 6.4643 2.2965C5.52662 3.23418 4.99984 4.50595 4.99984 5.83203V8.33203H4.1665C2.78579 8.33203 1.6665 9.45132 1.6665 10.832V16.6654C1.6665 18.0461 2.78579 19.1654 4.1665 19.1654H15.8332C17.2139 19.1654 18.3332 18.0461 18.3332 16.6654V10.832C18.3332 9.45132 17.2139 8.33203 15.8332 8.33203H14.9998ZM4.1665 9.9987C3.70627 9.9987 3.33317 10.3718 3.33317 10.832V16.6654C3.33317 17.1256 3.70627 17.4987 4.1665 17.4987H15.8332C16.2934 17.4987 16.6665 17.1256 16.6665 16.6654V10.832C16.6665 10.3718 16.2934 9.9987 15.8332 9.9987H4.1665Z",
    fill: "#4C4D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f0722b40c91bf0002de51affdd9baf81.svg";
export { ForwardRef as ReactComponent };